import React from 'react';
import colours from 'styles/colours';
import Title from 'components/Text/Title';

export default function AuthenticationContainer(props) {

    const {title, children} = props;

    const containerStyles = {
        width: 400,
        height: 'fit-content',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, .1)',
        marginTop: 50,
    };

    const bannerStyles = {
        padding: '12px 20px',
        backgroundColor: colours.background.banner
    };

    const contentStyles = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '25px 20px 15px',
        alignItems: 'flex-start',
    };

    return (
        <article style={containerStyles}>
            <div style={bannerStyles}>
                <Title colour={colours.font.contrast}>{title}</Title>
            </div>
            <form style={contentStyles} onSubmit={event => event.preventDefault()}>
                {children}
            </form>
        </article>
    );

}